<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <div *ngIf="coopId === '0'">
            <tt-input ttLabel="coop_id" [(ttModel)]="edit.coop_id" ttRequired></tt-input>
            <tt-input ttLabel="coop_name" [(ttModel)]="edit.coop_name" ttRequired></tt-input>
        </div>

        <div *ngIf="coopId !== '0'">
            <tt-input ttLabel="coop_id" [ttModel]="edit.coop_id" ttReadonly></tt-input>
            <tt-input ttLabel="coop_name" [(ttModel)]="edit.coop_name" [ttButtons]="coopNameButtons" ttRequired></tt-input>
        </div>

        <tt-checkbox ttLabel="isactive" [(ttModel)]="edit.isactive"></tt-checkbox>
        <tt-button-save ttText="coop_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <div ng-if="vm.model.coopId === '0'">
            <tt-input class="col-xs-12 sp-0" tt-label="coop_id" tt-model="vm.model.edit.coop_id" tt-change="vm.model.edit.coop_id = $value" tt-readonly="false" tt-required="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="coop_name" tt-model="vm.model.edit.coop_name" tt-change="vm.model.edit.coop_name = $value" tt-placeholder="" tt-required="true"></tt-input>
        </div>

        <div ng-if="vm.model.coopId !== '0'">
            <tt-input class="col-xs-12 sp-0" tt-label="coop_id" tt-model="vm.model.edit.coop_id" tt-change="vm.model.edit.coop_id = $value" tt-readonly="true"></tt-input>
            <tt-input-buttons class="col-xs-12 sp-0" tt-label="coop_name" tt-model="vm.model.edit.coop_name" tt-change="vm.model.edit.coop_name = $value" tt-placeholder="" tt-buttons="vm.model.coopNameButtons" tt-required="true"></tt-input-buttons>
        </div>

        <tt-checkbox class="col-xs-12 sp-0" tt-label="isactive" tt-model="vm.model.edit.isactive" tt-change="vm.model.edit.isactive = $value"></tt-checkbox>
        <tt-button-save class="col-xs-12 sp-0" tt-text="coop_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
    </tt-card>
</tt-page>-->
